import { BulkDeleteOrderRequest } from '@/coreInfrastructureModule/axios/generated/orderManage';

/**
 * 発注の削除apiのアダプタ
 */
export class BulkDeleteOrderAdapter {
  /**
   * UI用からapi用に変換する
   * @param orderIds - 削除する発注ID
   */
  public static adaptForRequest(orderIds: string[]): BulkDeleteOrderRequest {
    return { bulkDeleteOrderInfos: orderIds.map((orderId) => ({ orderId })) };
  }
}
